/* eslint @typescript-eslint/ban-types: 0  */
export function safeCallback(callback) {
    var parameters = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        parameters[_i - 1] = arguments[_i];
    }
    if (typeof callback === 'function')
        callback.apply(void 0, parameters);
}
